module.exports = __webpack_public_path__ + "img/icn_all_leads.d8c0952b.svg";